export default __webpack_public_path__ + "static/media/e-filing-picturemark-l.7d5328b5.svg";